var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_386_282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 300.961H135.529V371.235L200.784 381.275L256 371.235L266.039 338.775L256 300.961Z",
    fill: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.471 371.235V300.96H256V371.235L316.235 381.274L376.471 371.235ZM451.765 120.254H512V150.372H451.765V120.254ZM413.516 223.868L434.809 202.576L477.396 245.162L456.103 266.455L413.516 223.868ZM413.535 46.8295L456.123 4.24316L477.416 25.5363L434.83 68.1227L413.535 46.8295Z",
    fill: "#FFB64C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 120.255H60.2353V150.372H0V120.255ZM34.4917 245.13L77.0781 202.544L98.3713 223.839L55.7859 266.424L34.4917 245.13ZM34.5198 25.4954L55.814 4.20117L98.4004 46.7875L77.1072 68.0817L34.5198 25.4954Z",
    fill: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 371.235H90.3525V441.51L175.016 451.549L256 441.51L266.039 406.373L256 371.235Z",
    fill: "#FF9963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 441.51L334.306 451.549L421.647 441.51V371.235H256V441.51Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.086 85.1446L120.363 98.7628L188.181 164.87L172.172 258.214L256 214.142L266.039 135.314L256 0.21582L214.086 85.1446Z",
    fill: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.819 164.87L391.637 98.7628L297.914 85.1446L256 0.21582V214.142L339.828 258.214L323.819 164.87Z",
    fill: "#FFB64C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3532 441.51H45.1768V511.784H256L266.04 476.647L256 441.51H90.3532Z",
    fill: "#007680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.824 441.51H256V511.784H466.824V441.51Z",
    fill: "#0D5767"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV5);
export default __webpack_public_path__ + "static/media/V5.3d32c24c9052d8e4e1b6ba58b00c4f5b.svg";
export { ForwardRef as ReactComponent };